// eslint-disable-next-line no-unused-vars
import React, {useState, useEffect} from 'react';
import { withStyles } from '@material-ui/core/styles';

import { connect } from "react-redux";
import { PAGES } from "../enum/pages";
import { EVENTCODES } from "../enum/eventCodes";
import { setPage, setEventCode } from "../redux/actions";

import { withTranslation } from 'react-i18next';
import i18n from "i18next";

import API from "../utils/API";
import { getBannerImageUrlLabel, getBannerRedirectUrl } from "../utils/EventBanner"

import TextInputField from 'widgets/TextInputField';
import TitleSelectBox from 'widgets/TitleSelectBox';
import SubmitButton from 'widgets/SubmitButton';

import MotisVerticallyCenteredModal from 'widgets/MotisVerticallyCenteredModal';
import ConfirmationPanel from "widgets/ConfirmationPanel";

import leadFormDataen from '../i18n/en/leadForm.json';
import leadFormDatazh from '../i18n/zh/leadForm.json';

const styles = () => ({
	root: {
		maxWidth: 1075,
		margin: ".45em auto",
	},
	content: {
	    textAlign: "center",
	},
	submit_document_title: {
	    fontSize: "1.75em",
	},
	coreForm: {
	    paddingTop: 5,
	},
	rowFixMargin: {
		margin: 0,
	},
	greyLink: {
	    color: "grey",
	    padding: "2em",
	    textDecoration: "underline",
	},
	
	motisInfoBox: {},
	motisInfoBoxContent: {
	    backgroundColor: "#efefef",
	    padding: "1em 1.6em",
		fontFamily: "AIGFutura_Book",
	},
	loadingIconDataUrlContainer: {
	    height: "19em",
	    display: "inline-flex",
	    width: "100%",
	},
	loadingIconDataUrl: {
	    alignSelf: "center",
	    margin: "0 auto",
	},
	panelTitle: {
		fontWeight: "bold",
		textAlign: "center",
		color: "#0070BA",
		width: "100%",
		fontSize: "1.75em",
		marginBottom: ".5em",
	},
	panelDescription: {
		textAlign: "center",
		marginTop: -10,
		marginBottom: 20,
		color: "#00a4e4",
	},
	confirmationPanelsContainer: {
		backgroundColor: "#eeefef",
	},
	bannerContainer: {
		padding: "1.5em 0",
	},
	bannerImage: {
		width: "100%",
	}
});

function formPage(props) {
	const { classes, t,
		setPage, setEventCode		// props from mapDispatchToProps
	} = props;

	const getUrlVars = () => {
	    var vars = {};
	    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
	        vars[key] = value;
	    });
	    return vars;
	};

	const travel_10_off_banner_url_en = window.travel_10_off_banner_url_en;
	const travel_10_off_banner_url_zh = window.travel_10_off_banner_url_zh;

	const event_Url = window.event_API_URL;
	const save_URL = window.save_API_URL;

	// const rootElement = document.getElementById('root');
	// const event_API = rootElement.getAttribute('event_api');
	// const save_API = rootElement.getAttribute('save_api');


	const event_cd = getUrlVars()["event_cd"] ? getUrlVars()["event_cd"].replace("#", "") : "";
	const langCode = i18n.language;

	const [validEvent, updateValidEvent] = useState(false);

	const [titleCode, updateTitleCode] = useState("");
	const [username, updateUsername] = useState("");
	const [email, updateEmail] = useState("");
	const [tel, updateTel] = useState("");
	const [policyNo, updatePolicyNo] = useState("");

	const [confirmationStatus, updateConfirmationStatus] = useState(false);
	const [optOutStatus, updateOptOutStatus] = useState(false);

	const [titleErrorMessage, updateTitleErrorMessage] = useState("");
	const [usernameErrorMessage, updateUsernameErrorMessage] = useState("");
	const [emailErrorMessage, updateEmailErrorMessage] = useState("");
	const [telErrorMessage, updateTelErrorMessage] = useState("");
	const [policyNoErrorMessage, updatePolicyNoErrorMessage] = useState("");
	
	const [showFailModal, setShowFailModal] = React.useState(false);
	const [failSubmissionDescription, setFailSubmissionDescription] = React.useState("");

	const [showPIModal, setShowPIModal] = React.useState(false);


	useEffect(() => {
        setEventCode(event_cd);


		// alert user if event_cd is incorrect
		if(!Object.values(EVENTCODES).includes(event_cd)) {
			setFailSubmissionDescription(t("invalid_event_code"));
			setShowFailModal(true);

			return;
		} else {
			const getEventDataForm = {
				eventCd: event_cd,
			};

			API.post(event_Url, getEventDataForm)
				.then(res => {
					if(res.data.success === true) {
						updateValidEvent(true);
					} else {
						setFailSubmissionDescription(t("event_is_not_opening"));
						setShowFailModal(true);

						return;
					}
				}).catch(err => {
					setFailSubmissionDescription(t("event_is_not_opening"));
					setShowFailModal(true);

					return;
				});
		}
	}, [event_cd]);

	const personalInformationCollectionClicked = (e) => {
		// `target` is the element the click was on (the div we hooked or an element
		// with in it), `currentTarget` is the div we hooked the event on
		const el = e.target;

		if (el && el.tagName === "A" && el.attributes['data-content'] && el.attributes['data-content'].value === "data-private-policy") {
			// private policy is going to show
            setShowPIModal(true);
		}
	}

	const submitLeadForm = () => {
		if(!Object.values(EVENTCODES).includes(event_cd)) {
			setFailSubmissionDescription(t("invalid_event_code"));
			setShowFailModal(true);

			return;
		} else if(validEvent === false) {
			setFailSubmissionDescription(t("event_is_not_opening"));
			setShowFailModal(true);

			return;
		}

		const transactionDataForm = {
			eventCd: event_cd,
			titleCd: titleCode,
			name: username,
			emailAddress: email,
			contactNo: tel,
			lang: langCode,
			optOut: optOutStatus,
			policyNo: policyNo
	    };
		
		// update error message for each select / input fields
		updateTitleErrorMessage((titleCode === "") ? t("error_message_of_missing_required_field") : "");
		updateUsernameErrorMessage((username === "") ? t("error_message_of_missing_required_field") : "");
		updateEmailErrorMessage((email === "") ? t("error_message_of_missing_required_field") : "");
		updateTelErrorMessage((tel === "") ? t("error_message_of_missing_required_field") : "");
		updatePolicyNoErrorMessage((policyNo === "")? t("error_message_of_missing_required_field"):"");

		if(titleCode === "" || username === "" || email === "" || tel === "" || policyNo === "") {
			setFailSubmissionDescription(t("missing_required_information"));
			setShowFailModal(true);
			
			return;
		} else if(!(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/.test(email))) {
			updateEmailErrorMessage(t("err_for_wrong_email_format"));
			setFailSubmissionDescription(t("missing_required_information"));
			setShowFailModal(true);

			return;
        } else if(!(/^[9865][0-9]{7}/i.test(tel))) {
			updateTelErrorMessage(t("err_mobileNo_msg"));
			setFailSubmissionDescription(t("missing_required_information"));
			setShowFailModal(true);

			return;
		}

		if (!confirmationStatus) {
			setFailSubmissionDescription(t("upload_form_not_agree_TNC_description"));
			setShowFailModal(true);

			return;
		}

        gtmFireEvent('travel-postpone-campaign','form submission','next_btn_click',{});

		API.post(save_URL, transactionDataForm)
    	.then(res => {
    		console.log(res);
    		if(res.data.success === true) {
    			setPage(PAGES.COMPLETE);
    		} else {
				setFailSubmissionDescription(t("fail_to_submit_lead_form"));
    			setShowFailModal(true);
    		}
    	});
	};

	return (
		<div className={classes.root}>

			<div className={`row center-xs middle-sm ${classes.rowFixMargin}`}>
				<div className={`col-xs-11 col-sm-10 col-lg-9`}>
					<div className={classes.content}>

						<div className={classes.bannerContainer}>
							{getBannerRedirectUrl(event_cd, langCode) === "" ?
								<img className={classes.bannerImage} src={t(getBannerImageUrlLabel(event_cd))}/>
								:
								<a href={t(getBannerRedirectUrl(event_cd, langCode))}>
									<img className={classes.bannerImage} src={langCode === 'zh' ? travel_10_off_banner_url_zh : travel_10_off_banner_url_en}/>
								</a>
							}
						</div>

						<div className={classes.motisInfoBox}>
							<div className={classes.motisInfoBoxContent}>
								<div className={classes.panelTitle}>
									{t("personal_information_panel_title")}
								</div>

								<div className={classes.coreForm}>

									<div className="panel-content">
										<div className="row around-xs">
											<div className="col-xs" className={classes.panelDescription}>
												{t("personal_information_panel_description")}
											</div>
										</div>
										<div className="row around-xs">
											<div className="col-xs-4 col-sm-3">
												<div className="box">
													<TitleSelectBox
														errorMessage={titleErrorMessage}
														onChangeEvent={updateTitleCode}
													/>
												</div>
											</div>
											<div className="col-xs-8 col-sm-9">
												<div className="box">
													<TextInputField
														textAlign="center"
														placeholder={t("username_placeholder")}
														errorMessage={usernameErrorMessage}
														onChangeEvent={event => updateUsername( event.target.value )}
													/>
												</div>
											</div>
										</div>
										<div className="row around-xs">
											<div className="col-xs-12">
												<div className="box">
													<TextInputField
														textAlign="center"
														placeholder={t("policy_no_placeholder")}
														errorMessage={policyNoErrorMessage}
														onChangeEvent={event => updatePolicyNo( event.target.value )}
													/>
												</div>
											</div>
										</div>
										<div className="row around-xs">
											<div className="col-xs-12 col-sm-6">
												<div className="box">
													<TextInputField
														textAlign="center"
														placeholder={t("email_placeholder")}
														errorMessage={emailErrorMessage}
														onChangeEvent={event => updateEmail( event.target.value )}
													/>
												</div>
											</div>
											<div className="col-xs-12 col-sm-6">
												<div className="box">
													<TextInputField
														textAlign="center"
														placeholder={t("contact_number_placeholder")}
														errorMessage={telErrorMessage}
														onChangeEvent={event => updateTel( event.target.value )}
													/>
												</div>
											</div>
										</div>
									</div>

								</div>

							</div>
						</div>

						<div className={classes.confirmationPanelsContainer}>
							<ConfirmationPanel
								label={t("lead_Form_Confirmation_text")}
								description={t("lead_Form_Confirmation_description")}
								onLabelClick={personalInformationCollectionClicked}
								onClick={
									checkedState => {updateConfirmationStatus(checkedState)}
								}
							/>

							<ConfirmationPanel
								label={t("lead_Form_opt_out_label")}
								appendPanel={1}
								onClick={
									checkedState => {updateOptOutStatus(checkedState)}
								}
							/>
						</div>

						<SubmitButton
							label="submit_label"
							onClickEvent={() => submitLeadForm()}
						/>

					</div>

				</div>
			</div>

		<MotisVerticallyCenteredModal
			header_title={t("error_modal_title")}
			allow_dangerously_set_innerhtml_on_content={1}
			content_string={failSubmissionDescription}
			show={showFailModal}
			onHide={() => setShowFailModal(false)}
		/>

		<MotisVerticallyCenteredModal
			header_title={t("personal_information_modal_title")}
			allow_dangerously_set_innerhtml_on_content={1}
			content_string={t("personal_information_modal_description")}
			show={showPIModal}
			onHide={() => setShowPIModal(false)}
		/>

		</div>
	);
}

const mapStateToProps = state => {
	const {} = state;

	return {};
};

export default connect(mapStateToProps, {setPage, setEventCode})(
	withTranslation()(
		withStyles(styles)(formPage)
	)
);